// prevent the mousewheel from incrementing number fields
document.addEventListener("mousewheel", function(event){
    if(document.activeElement.type === "number"){
        document.activeElement.blur();
    }
});



// WEBPACK FOOTER //
// ./src/Assets/utils.js